module.exports = __webpack_public_path__ + "static/media/HollowTappingLong.e1c2e09f.mp3";